import { useCallback } from 'react';
import { trackAnalytics } from 'common/components/CopyMagic/shared/dataHelpers';

import { MESSAGE_DATA_ROLES, OPEN_AI_CODE_WRAPPER } from 'common/components/CopyMagic/constants';
import type { MessageType } from 'common/components/CopyMagic/contexts/MessagesContext/MessagesContext.types';
import { useMessagesContext } from 'common/components/CopyMagic/contexts/MessagesContext';
import { useUiResourceContext, useConfigContext } from 'common/components/CopyMagic/contexts';
import useChatSessionId from 'common/components/CopyMagic/hooks/useChatSessionId';

const useTrackMessageFeedbackSentiment = () => {
  const { productEvents } = useConfigContext();
  const { findMessagesBy } = useMessagesContext();
  const { sessionId } = useUiResourceContext();
  const { getChatSessionId } = useChatSessionId();

  const trackCallback = useCallback(
    ({ message, positiveFeedback }: { message: MessageType; positiveFeedback: boolean }) => {
      const trackProductAnalytics = trackAnalytics(productEvents);
      const chatSessionId = getChatSessionId();

      trackProductAnalytics('Rated', {
        'Message Created At': message.createdAt,
        'Message Content': message.data.content,
        'Message Character Count': message.data.content.length,
        'Message Includes Code': message.data.content.includes(OPEN_AI_CODE_WRAPPER),
        'User Messages Count': findMessagesBy({ role: MESSAGE_DATA_ROLES.USER }).length,
        'Rating': positiveFeedback ? 1 : 2, // eslint-disable-line quote-props
        'Session ID': sessionId, // session id is set each time the drawer is opened
        'Chat Session ID': chatSessionId, // chat session id tracks the entire conversation history
      });
    },
    [productEvents, findMessagesBy, sessionId],
  );

  return trackCallback;
};

export default useTrackMessageFeedbackSentiment;
